module.exports = __webpack_public_path__ + "static/media/restage-hero@3x.3800a1f6.png";